/* eslint semi: 1 */

const defaultAppData = {
    builds: [],
    showAvailableBuiLds: false,
    contactFirstName: '',
    contactLastName: '',
    contactEmail: '',
    contactMessage: ''
};

export default (state = defaultAppData, action) => {

    const { type, payload } = action;

    switch(type) {
        case 'ADD_BUILDS':
            return Object.assign(
                {},
                state,
                {builds: payload.builds}
            );
        case 'TOGGLE_AVAILABLE_BUILDS':
            return Object.assign(
                {},
                state,
                {showAvailableBuilds: !state.showAvailableBuilds}
            );
        case 'UPDATE_CONTACT_FIRST_NAME':
        return Object.assign(
            {},
            state,
            {contactFirstName: payload.contactFirstName}
        );
        case 'UPDATE_CONTACT_LAST_NAME':
        return Object.assign(
            {},
            state,
            {contactLastName: payload.contactLastName}
        );
        case 'UPDATE_CONTACT_EMAIL':
        return Object.assign(
            {},
            state,
            {contactEmail: payload.contactEmail}
        );
        case 'UPDATE_CONTACT_MESSAGE':
        return Object.assign(
            {},
            state,
            {contactMessage: payload.contactMessage}
        );
        case 'RESET_CONTACT_DATA':
        return Object.assign(
            {},
            state,
            {
                contactFirstName: '',
                contactLastName: '',
                contactEmail: '',
                contactMessage: ''
            }
        );
        default:
            return defaultAppData;
    }

};



/** WEBPACK FOOTER **
 ** ./src/reducers/app-reducer.js
 **/